import { Injectable } from '@angular/core';
import { UntypedFormControl, FormGroup } from '@angular/forms';


@Injectable()
export class SharedFunctionsService {

  public apiValidStringAlert: string = "Please enter a valid API number with at most 14 numeric characters and 4 dashes."

  checkIE() {
    var isIE = false;
    //var ua = window.navigator.userAgent;
    //var old_ie = ua.indexOf('MSIE ');
    //var new_ie = ua.indexOf('Trident/');

    //if ((old_ie > -1) || (new_ie > -1)) {
    //  isIE = true;
    //}

    return isIE;
  }

  getDateForDateOffSet(strDate: any ) {
    if (null !== strDate && typeof strDate !== "undefined") {
      if (typeof strDate === "string") {
        let startDate = strDate.substring(0, strDate.indexOf("T"))
        startDate = startDate.replace(/-/g, "/")
        return new Date(startDate)
      } else {
        return strDate;
      }
    }
    else {
      return null;
    }
  }

  sortArray(arrayList: Array<any>, key: string, sortArrayObj: any) {
    arrayList.sort(function (a: any, b: any): any {
      switch (typeof a[key]) {
        case "string":
          let nameA = a[key] == null ? "" : a[key].toUpperCase(); // ignore upper and lowercase
          let nameB = b[key] == null ? "" : b[key].toUpperCase(); // ignore upper and lowercase
          if (sortArrayObj[key]) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          }
          else {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
          }
          // names must be equal
          return 0;
          break;
        case "number":
          if (!sortArrayObj[key]) {
            return b[key] - a[key];
          }
          return a[key] - b[key];
          break;
        default:
          let nameC = a[key] == null ? "" : a[key].toUpperCase(); // ignore upper and lowercase
          let nameD = b[key] == null ? "" : b[key].toUpperCase(); // ignore upper and lowercase
          if (sortArrayObj[key]) {
            if (nameC < nameD) {
              return -1;
            }
            if (nameC > nameD) {
              return 1;
            }
          }
          else {
            if (nameD < nameC) {
              return -1;
            }
            if (nameD > nameC) {
              return 1;
            }
          }
          // names must be equal
          return 0;
      }      
    });
    return arrayList;
  }

  validIntInputs(control: any) {
    if (control.value) {

      if (((control.value % 1) == 0) || null == control.value) {
        return null;
      }
      else {
        return { 'invalidNumber': true };
      }

    }
    else {
      return null;
    }
  }

  validNonNegIntInputs(control: any) {
    if (control.value) {

      if (((control.value % 1) == 0) && control.value >= 0 || null == control.value) {
        return null;
      }
      else {
        return { 'invalidNumber': true };
      }

    }
    else {
      return null;
    }
  }

  validFloatInput(control: any) {
    if (control.value) {

      let point: number = 0;
      let valid: boolean = true;
      let val: string = control.value;
      let controlChar: Array<any> = val.toString().split('');
      controlChar.forEach(char => {
        if (char == '.') {
          point = point + 1;
        }
        else {
          if (char >= '0' && char <= '9') {
          } else {
            valid = false
          }
        }
      });
      if (valid && point <= 1) {
        return null;
      }
      else {
        return { 'invalidString': true };
      }
    }
    else {
      return null;
    }

  }

  validPosNegFloatInput(control: any) {

    if (control.value) {
      let point: number = 0;
      let valid: boolean = true;
      let val: string = control.value;
      let controlChar: Array<any> = val.toString().split("");
      controlChar.forEach((char, index) => {
        if (char == '.') {
          point = point + 1;
        }
        else if (char == '-') {
          if (index != 0) {
            valid = false
          }
        }
        else {

          if (char >= '0' && char <= '9') {
          } else {
            valid = false
          }
        }
      });
      if (valid && point <= 1) {
        return null;
      }
      else {
        return { 'invalidString': true };
      }
    }
    else {
      return null;
    }

  }

  validAPIstring(formControl: UntypedFormControl) {
    if (formControl.value) {
      let apiChar: Array<any> = formControl.value.split("");
      let numericCount: number = 0;
      let dashCount: number = 0;
      if ((formControl.value.replaceAll('-', 1) % 1) != 0) { return { 'invalidString': true }; }

      apiChar.forEach(char => {
        if (char == "-") {
          dashCount += 1;
        } else if (char % 1 == 0) {
          numericCount += 1;
        } else {
          return { 'invalidString': true };
        }
      })

      if (numericCount > 14) {
        return { 'invalidString': true };
      }
      if (dashCount > 4) {
        return { 'invalidString': true };
      }
      return null;
    }
    else {
      return null;
    }
  }

  validPercentage(control: any) {
    if (control.value) {
      if ((!Number.isNaN(control.value) && control.value >= 0 && control.value <= 1) && control.value.toString().trim() != "" || null == control.value) {
        return null;
      }
      else {
        return { 'invalidString': true };
      }

    }
    else {
      return null;
    }
  }

}

export enum state {
  cloneMode = 2,
  createMode = 1,
  editMode = 0
}


